/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Location/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Location({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/PatientSelect/Content/Content/Existing/PatientPreview/Content/Location"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let patientPrimaryLocationNameValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: 'primary_location.name',
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let constantData = '#'
let patientHumanReadableIdValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: 'human_readable_id',
})
let aggregateData = fromAggregate.joinNoSpace(constantData, patientHumanReadableIdValueData)
  return (<React.Fragment
>
<div
  data-testid="Location.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-2jX8FA': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 data="patient.primary_location.name"
 text={patientPrimaryLocationNameValueData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 text="•"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 data="'#'"
 data="patient.human_readable_id"
 aggregate="/Data/aggregate.js joinNoSpace"
 text={aggregateData}
/>
</div>
{children}
</React.Fragment>)
}